export const examResultsEndpoints = {
    process: "/api/exam-results/process",
    status: (jobId: string): string => `/api/exam-results/status/${jobId}`,
} as const;
